import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconReplay"><Path d="M10.25 15.25V8.75L15.25 12L10.25 15.25Z" fill="currentColor"/><Path d="M3.5 3V8H8.5" stroke="currentColor"/><Path d="M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C8.51707 3 5.49623 4.97844 4 7.8728" stroke="currentColor"/></CentralIconBase>;
});

export default IconReplay;
